<h1>Mentions Légales</h1>
<div class="content">
  <p>
    L'utilisation du site internet
    <a href="https://dataviz.metiers-btp.fr/"
      >https://dataviz.metiers-btp.fr/</a
    >
    implique l'acceptation pleine et entière par les utilisateurs des présentes
    conditions générales d'utilisation. Celles-ci sont susceptibles d'être
    modifiées à tout moment ; les utilisateurs du site dataviz.metiers-btp.fr
    sont donc invités à les consulter de manière régulière afin d'en prendre
    connaissance.
  </p>

  <h2>INFORMATION ÉDITEUR</h2>
  <p>
    Le présent site
    <a href="https://dataviz.metiers-btp.fr/">https://dataviz.metiers-btp.fr/</a
    >, son contenu et son nom de domaine sont la propriété exclusive de :
  </p>
  <p>
    Opérateur de Compétences de la Construction, Constructys - qui héberge
    l'Observatoire Prospectif des Métiers et des Qualifications du BTP (OPMQ
    BTP)
  </p>
  <ul>
    <li>Forme juridique : Association</li>
    <li>
      Siège social : 32 rue René BOULANGER - CS 60033-75483 Paris Cedex 10
    </li>
    <li>Téléphone : 01 82 83 95 00</li>
    <li>Numéro SIREN : 533 846 150</li>
    <li>Responsable de l'Observatoire des Métiers du BTP : Hervé DAGAND</li>
    <li>
      Responsabilité éditoriale : elle est assurée par le comité éditorial. Pour
      toute suggestion, information, réaction concernant ce site, contactez le
      responsable internet.
    </li>
  </ul>
  <h3>Hébergeur</h3>
  <p>
    OVH Groupe SAS, société immatriculée au RCS de Lille sous le numéro 537 407
    926 sise 2, rue Kellermann, 59100 Roubaix.
  </p>
  <h3>Conception et développement</h3>
  <p>
    <a href="https://www.labonneagence.com" target="_blank" rel="noopener"
      >La Bonne Agence</a
    >
  </p>

  <h2>PROPRIÉTE INTELLECTUELLE</h2>
  <p>
    L'ensemble de ce site relève de la législation française et internationale
    sur le droit d'auteur et la propriété intellectuelle. Tous les droits de
    reproduction sont réservés. Tous les documents téléchargeables et les
    représentations iconographiques et photographiques présents sur le site,
    sont la propriété exclusive de Constructys et de ses partenaires. Tout autre
    usage du contenu doit être soumis à une autorisation préalable et expresse
    de l'OPMQ, notamment dans le cas où l'utilisateur envisagerait de rediffuser
    le contenu sur un autre site. La violation de ces dispositions impératives
    soumet le contrevenant, et toutes personnes responsables, aux peines pénales
    et civiles prévues par la loi. L'OPMQ se réserve le droit de modifier le
    site à tout moment, de supprimer ou de modifier de plein droit certaines des
    fonctionnalités du site, sans préavis ni indemnité.
  </p>

  <h2>POLITIQUE DE PROTECTION DES DONNÉES PERSONNELLES</h2>
  <p>
    Conformément au Règlement européen (UE) 2016/679 du 27 avril 2016 relatif à
    la protection des données personnelles, et à la loi Informatique et libertés
    du 6 janvier 1978 modifiée, vous disposez de la faculté d'exercer vos droits
    (notamment d'accès ou de rectification) relatifs aux informations qui vous
    concernent.
  </p>

  <h2>COOKIES</h2>
  <p>
    Lors de l'accès au site, des cookies peuvent être installés automatiquement
    et être conservés temporairement en mémoire ou sur votre disque dur, afin de
    faciliter votre navigation. Un cookie ne nous permet pas de vous identifier
    mais est un élément qui sert à enregistrer des informations relatives à la
    navigation sur le site web. Vous pouvez également refuser l'enregistrement
    des cookies en modifiant les paramètres de votre navigateur Internet. Cette
    opération entraînera cependant la suppression de tous les cookies utilisés
    par le navigateur, y compris ceux employés par d'autres sites web, ce qui
    peut conduite à l'altération ou la perte de certains réglages ou
    informations et à rendre difficile la navigation sur le site web.
  </p>
</div>
